import RefreshIcon from '@mui/icons-material/Refresh';
import { Button, Stack, Typography } from '@mui/material';

import {
  DEFAULT_ERROR_BODY_TEXT,
  DEFAULT_ERROR_HEADER_TEXT,
} from 'portal/src/constants/errorText';

export default function UserLoadingError({
  onRefreshClick,
}: {
  onRefreshClick: () => void;
}) {
  return (
    <Stack
      alignItems="center"
      justifyContent="center"
      height="60vh"
      spacing={2}
    >
      <Typography variant="h3">{DEFAULT_ERROR_HEADER_TEXT}</Typography>
      <Typography variant="body1">{DEFAULT_ERROR_BODY_TEXT}</Typography>
      <Button
        variant="contained"
        startIcon={<RefreshIcon />}
        onClick={() => onRefreshClick()}
      >
        Refresh
      </Button>
    </Stack>
  );
}
